import { Field, FinalFormInput } from "@comet/admin";
import { type VividFieldProps } from "@src/components/fields/interfaces";
import { type FC, type PropsWithChildren } from "react";

export const InputField: FC<PropsWithChildren<VividFieldProps>> = ({ required = true, variant, label, ...rest }) => {
    const effectiveVariant = variant ?? (label ? "horizontal" : "vertical");
    return (
        <Field fullWidth required={required} component={FinalFormInput} fieldContainerProps={{ variant: effectiveVariant }} label={label} {...rest} />
    );
};
